import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import { withRouter } from 'kts-platform-frame/routes';
import { AppKey } from 'kts-platform-frame/entry/constant';
import { Link } from 'react-router-dom';
import { Menu, Icon } from 'antd';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import appStore from 'kts-platform-frame/api/appStore';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import language from 'kts-platform-frame/language';
import Advisory from 'kts-qiyu-advisory';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    menuAppList?: IAppInfo[];
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 辅助功能- */
@withRouter
@ModulesAction.uiconnect
@language.associate
@connect((state: ReduxState): IReduxStatePart => ({
    menuAppList: state.system.menuAppList
}))
export default class UIAppList extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount() {
        appStore.queryMenuApp(this);
    }

    render() {
        const { location } = this.props;
        return (
            <Menu
                theme="dark"
                inlineIndent={15}
                mode="inline"
                selectedKeys={[ModulesAction.getMenuSelectedKeys(location.pathname)]}
                inlineCollapsed={this.modulesState.collapsed}
            >
                {
                    ModulesAction.isInstallApp(AppKey.帮助中心) &&
                    <Menu.Item key="/workbench/platform/help">
                        <Advisory useCustomIcon={true}>
                            <Link to="#">
                                <Icon type="bangzhu" />
                                <span>帮助中心</span>
                            </Link>
                        </Advisory>
                    </Menu.Item>
                    
                }
                {
                    this.isHaveSystemManagement &&
                    <Menu.SubMenu
                        className={css.menuSubMenu}
                        title={<span><Icon type="shezhi" /><span>系统管理</span></span>}
                    >
                        {
                            ModulesAction.isInstallApp(AppKey.用户管理) &&
                            <Menu.Item key="/workbench/platform/usermanage">
                                <Link to="/workbench/platform/usermanage">
                                    <span className={css.p15}>用户管理</span>
                                </Link>
                            </Menu.Item>
                        }
                        {
                            ModulesAction.isInstallApp(AppKey.角色管理) &&
                            <Menu.Item key={`/workbench/m/${AppKey.角色管理}`}>
                                <Link to={`/workbench/m/${AppKey.角色管理}`}>
                                    <span className={css.p15}>角色管理</span>
                                </Link>
                            </Menu.Item>
                        }
                        {
                            ModulesAction.isInstallApp(AppKey.部门管理) &&
                            <Menu.Item key="/workbench/platform/organization">
                                <Link to="/workbench/platform/organization">
                                    <span className={css.p15}>部门管理</span>
                                </Link>
                            </Menu.Item>
                        }
                        {
                            ModulesAction.isInstallApp(AppKey.公司信息) &&
                            <Menu.Item key="/workbench/platform/companyinfo">
                                <Link to="/workbench/platform/companyinfo">
                                    <span className={css.p15}>公司信息</span>
                                </Link>
                            </Menu.Item>
                        }
                        {
                            ModulesAction.isInstallApp(AppKey.集团资料) &&
                            <Menu.Item key="/workbench/platform/groupInfo">
                                <Link to="/workbench/platform/groupInfo">
                                    <span className={css.p15}>集团资料</span>
                                </Link>
                            </Menu.Item>
                        }
                        {
                            ModulesAction.isInstallApp(AppKey.审计日志) &&
                            <Menu.Item key={`/workbench/m/${AppKey.审计日志}`}>
                                <Link to={`/workbench/m/${AppKey.审计日志}`}>
                                    <span className={css.p15}>审计日志</span>
                                </Link>
                            </Menu.Item>
                        }
                        {
                            ModulesAction.isInstallApp(AppKey.应用管理) &&
                            <Menu.Item key="/workbench/platform/appStore/appManage">
                                <Link to="/workbench/platform/appStore/appManage">
                                    <span className={css.p15}>应用管理</span>
                                </Link>
                            </Menu.Item>
                        }
                    </Menu.SubMenu>
                }
            </Menu>
        );
    }

    private get isHaveSystemManagement(): boolean {

        if (ModulesAction.isInstallApp(AppKey.用户管理)) {
            return true;
        }

        if (ModulesAction.isInstallApp(AppKey.公司信息)) {
            return true;
        }

        if (ModulesAction.isInstallApp(AppKey.集团资料)) {
            return true;
        }

        if (ModulesAction.isInstallApp(AppKey.部门管理)) {
            return true;
        }

        if (ModulesAction.isInstallApp(AppKey.应用管理)) {
            return true;
        }

        if (ModulesAction.isInstallApp(AppKey.审计日志)) {
            return true;
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench/UI.Aide.tsx